import { render, staticRenderFns } from "./dynamic.vue?vue&type=template&id=3f438a70&scoped=true&"
import script from "./dynamic.vue?vue&type=script&lang=js&"
export * from "./dynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f438a70",
  null
  
)

export default component.exports